import React from "react";

import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import chancellorImage from "../assets/img/leadership/Dr. Vinay M. Agrawal.webp";

export default function HonorableChancellor() {
  return (
    <>
      <MetaInfo param="" id="about" />

      <Header school="common" />

      <main className="overflow-hidden bg-white text-[#132337]">

        <section className="relative isolate min-h-[60vh] overflow-hidden bg-[#071A2F] text-white">
          <div className="absolute inset-0 -z-30 bg-[#071A2F]" />
          <div className="absolute left-0 top-0 -z-20 h-full w-full bg-[radial-gradient(circle_at_15%_20%,rgba(139,30,63,0.24),transparent_32%),radial-gradient(circle_at_80%_15%,rgba(213,173,87,0.16),transparent_28%)]" />
          <div className="absolute right-0 top-0 -z-10 hidden h-full w-[46%] border-l border-white/10 bg-white/[0.025] lg:block" />
          <div className="absolute right-[7%] top-[18%] -z-10 hidden h-[420px] w-[420px] rounded-full border border-[#D5AD57]/15 xl:block" />
          <div className="absolute right-[11%] top-[23%] -z-10 hidden h-[320px] w-[320px] rounded-full border border-white/10 xl:block" />

          <div className="mx-auto grid min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-end gap-12 pb-0 pt-[70px] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1fr_500px] lg:items-center lg:gap-20 lg:pb-0">
            <div className="max-w-[700px]">
              <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                <span className="h-px w-12 bg-current" />
                Hon'ble Chancellor
              </div>

              <h1 className="mt-7 max-w-[820px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.2vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">
                Providing vision for
                <span className="block text-[#D5AD57]">
                  the University&apos;s future.
                </span>
              </h1>

              <p className="mt-8 max-w-[620px] text-[17px] leading-8 text-white/65">
                Strategic leadership focused on education, empowerment, innovation and the continued development of ISBM University.
              </p>
            </div>

            <div className="relative self-end">
              <div className="absolute -left-8 top-16 hidden h-[72%] w-[1px] bg-[#D5AD57]/60 lg:block" />
              <div className="relative min-h-[560px] overflow-hidden bg-[#EAE5DA] sm:min-h-[640px] lg:min-h-[690px]">
                <img src={chancellorImage} alt="Dr. Vinay M. Agrawal" className="absolute inset-0 h-full w-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/45 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 border-t border-white/15 bg-[#071A2F]/75 px-7 py-6 backdrop-blur-md">
                  <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[26px] text-white">Dr. Vinay M. Agrawal</p>
                  <p className="mt-1 text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">Hon'ble Chancellor</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="relative bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">
          <div className="absolute left-0 top-0 h-full w-px bg-[#071A2F]/[0.04]" />
          <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[330px_1fr] lg:gap-24">
            <aside className="lg:sticky lg:top-[160px] lg:self-start">
              <div className="border-t border-[#8B1E3F] pt-6">
                <span className="text-xs font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">Hon'ble Chancellor</span>
                <h2 className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.05] text-[#071A2F]">Dr. Vinay M. Agrawal</h2>
              </div>

              <div className="mt-10 flex items-center gap-4 border-y border-[#071A2F]/10 py-6">
                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[64px] leading-none text-[#D5AD57]">“</span>
                <span className="h-px flex-1 bg-[#071A2F]/10" />
              </div>
            </aside>

            <div className="relative">
              <div className="absolute -left-10 top-0 hidden h-full w-px bg-[#071A2F]/10 lg:block" />
              <div className="space-y-8">
                <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,42px)] font-normal leading-[1.35] text-[#071A2F]">Education is an intervention in the modern society where, harmonious development can be achieved by enlightenment of an individual's heart, mind and soul. I am of the opinion that education can transform the attitude, thought process and lifestyle of the people leading to the development of the society Education makes people flexible in thinking rationally and making appropriate decisions. I have always worked towards empowering the mass. Education serves as the tool & technique of empowerment with skilled and socially relevant citizens.</p>
                <p className="text-[17px] leading-9 text-[#4F5D70]">ISBM University stands for humanism, rationality, idea exploration and innovation. The approach of our curriculum focuses on experiential learning ensuring better content delivery and provisions for co-curricular, extra-curricular activities as integral components of the learning process.</p>
                <p className="whitespace-pre-line text-[17px] leading-9 text-[#4F5D70]">At ISBM University we seek self-motivated individuals who believe in making their own methods of learning by availing the opportunities and willing to contribute their best for social welfare.
                  ISBM University is proud of its state of the art infrastructure, serene campus with aesthetically built facilities. Student's friendly policies create a satisfying academic ambience in the campus. I extend my best wishes to all the aspirants in the campus and assure them that under the mentorship of experienced faculties of ISBM University they will be able to extract competitive advantage towards creating a harmonious, peaceful and rewarding future. Participation in a wide range of academics and other activities will provide them an opportunity to acquire leadership, skills, professional and personal traits.</p>

              </div>
            </div>
          </div>
        </section>

      </main>

      <Footer />
    </>
  );
}
